import {INumberOrNaN} from "./models";

export function parseNaNText(value: INumberOrNaN | null | undefined): number {
    if (typeof value === "number") {
        return value;
    }

    if (value === "-Infinity") {
        return -Infinity;
    }

    if (value === "Infinity") {
        return Infinity;
    }

    return NaN;
}

export function parseNaNtoText(value: number): INumberOrNaN {
    if (isNaN(value)) {
        return "NaN";
    }

    if (value === -Infinity) {
        return "-Infinity";
    }

    if (value === Infinity) {
        return "Infinity";
    }

    return value;
}

export function sortChartData(
    x: number[],
    y: number[],
): {xSorted: number[]; ySorted: number[]} {
    if (x.length !== y.length) {
        return {xSorted: x, ySorted: y};
    }

    const data: {xValue: number; yValue: number}[] = [];
    x.forEach((value, i) => {
        data.push({xValue: value, yValue: y[i]});
    });

    data.sort((a, b) => a.xValue - b.xValue);

    const xSorted = [];
    const ySorted = [];
    for (const {xValue, yValue} of data) {
        xSorted.push(xValue);
        ySorted.push(yValue);
    }

    return {xSorted, ySorted};
}
